import { connect } from 'react-redux';
import { IProfileState } from '../../../redux';
import GenerateCredentials from './GenerateCredentials';

const mapStateToProps = (state: IProfileState) => ({
  client: state.profile.credentials.generate.client,
});

export default connect(mapStateToProps, null)(GenerateCredentials);
